VjsAdmin.StateSearchSelect = (() => {
    const init = (parent = document.querySelector('body')) => {
        const stateSelect2 = $('#state-search-select2');
        if (stateSelect2.hasClass('select2-hidden-accessible')) {
            return;
        }

        stateSelect2.select2({
            placeholder: 'Search for a state',
            theme: 'bootstrap4',
            dropdownParent: parent,
        });
    };

    return {
        init,
    };
})();
